import type { BasicQuestion } from "@repo/app-types/client/client";
import type { Company } from "@repo/app-types/entities/company";
import type {
  ProjectUpdate,
  ProjectWithInterviewCount,
} from "@repo/app-types/entities/project";
import type {
  ComplexQuestion,
  ComplexQuestionInsert,
} from "@repo/app-types/entities/question";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { type FC, useState } from "react";
import { OverviewBox } from "../../../components/overviewBox.js";
import { ReadOnlyBulletedList } from "../../../components/readOnlyBulletedList.js";
import { QuestionsManagerSlideover } from "./questionsManagerSlideover.js";

const NUM_QUESTIONS_TO_DISPLAY = 4;

interface ProjectSettingsQuestionsSectionProps {
  complexQuestions: (ComplexQuestion | ComplexQuestionInsert)[];
  basicQuestions: BasicQuestion[];
  project: ProjectWithInterviewCount;
  company: Company;
  onSaveProject: (changes: ProjectUpdate) => void;
}

/** Used to preview the interview questions on the project detail/settings page. */
export const ProjectSettingsQuestionsSection: FC<
  ProjectSettingsQuestionsSectionProps
> = ({ complexQuestions, basicQuestions, project, company, onSaveProject }) => {
  const [isQuestionsManagerSlideoverOpen, setIsQuestionsManagerSlideoverOpen] =
    useState(false);
  const questions = [...complexQuestions, ...basicQuestions];

  return (
    <div className="mb-2 flex flex-col justify-between">
      <div className="flex flex-col space-y-3">
        <div>
          {questions.length > 0 ? (
            <OverviewBox
              onClick={() => setIsQuestionsManagerSlideoverOpen(true)}
            >
              <ReadOnlyBulletedList
                items={questions.map((question) => question.question)}
                maxItemsToDisplay={NUM_QUESTIONS_TO_DISPLAY}
                itemDescriptor="questions"
              />
            </OverviewBox>
          ) : (
            <div className="mt-2">
              <Button
                variant={ButtonVariant.Primary}
                onClick={() => setIsQuestionsManagerSlideoverOpen(true)}
              >
                Add interview questions
              </Button>
            </div>
          )}
        </div>
      </div>

      <QuestionsManagerSlideover
        complexQuestions={complexQuestions}
        basicQuestions={basicQuestions}
        project={project}
        company={company}
        onSaveProject={onSaveProject}
        isOpen={isQuestionsManagerSlideoverOpen}
        onClose={() => setIsQuestionsManagerSlideoverOpen(false)}
      />
    </div>
  );
};
